/**
 * @file index.tsx
 *
 * @fileoverview Renders blogs page.
 */
import BlogsPage, { getServerSideProps } from '~/jobiqo/pages/blogs';
export default BlogsPage;
export { getServerSideProps };
